import React from 'react'
import { FormattedMessage } from 'react-intl'

import Spinner from 'components/Spinner'
import AutosaveIcon from 'assets/icons/auto-save-icon'

import { AutoSaveIconContainer, AutoSaveIconText } from './style'

const AutoSaveIcon = ({ loading }) => {
  return (
    <AutoSaveIconContainer data-testid='test-auto-save'>
      {loading ? (
        <AutoSaveIconContainer data-testid='test-saving-mode'>
          <Spinner />
          <AutoSaveIconText>
            <FormattedMessage id="saving" />
          </AutoSaveIconText>
        </AutoSaveIconContainer>
      ) : (
        <AutoSaveIconContainer data-testid='test-autoSave-mode'>
          <AutosaveIcon />
          <AutoSaveIconText>
            <FormattedMessage id="autoSave" />
          </AutoSaveIconText>
        </AutoSaveIconContainer>
      )}
    </AutoSaveIconContainer>
  )
}

export default AutoSaveIcon
